import FooterMobile from '../../components/Footer/mobile/FooterMobile';
import useIsDevice from '../../hooks/useIsDevice';
import MainDesktop from './desktop/MainDesktop';
import s from './Main.module.scss';
import MainMobile from './mobile/MainMobile';

function Main() {
  const { isMobile } = useIsDevice();
  return (
    <div className={s.container}>
      {/* {isMobile ? <HeaderMobile /> : null} */}
      <div>{isMobile ? <MainMobile /> : <MainDesktop />}</div>
      {isMobile ? <FooterMobile /> : null}
    </div>
  );
}

export default Main;
